/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  ValidateEcoModulationImportValidateMutationRequest,
  ValidateEcoModulationImportValidateMutationResponse,
  ValidateEcoModulationImport,
} from "../types/ValidateEcoModulationImport.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const validateEcoModulationImportValidateMutationKey = () =>
  [{ url: "/v1/eco-modulations/validate-import" }] as const

export type ValidateEcoModulationImportValidateMutationKey = ReturnType<
  typeof validateEcoModulationImportValidateMutationKey
>

/**
 * @description Validates CSV content, matches products, and caches pending upserts when there are no errors.
 * @summary Validate eco-modulation import CSV (Step 1)
 * {@link /v1/eco-modulations/validate-import}
 */
export async function validateEcoModulationImport(
  data: ValidateEcoModulationImportValidateMutationRequest,
  config: Partial<
    RequestConfig<ValidateEcoModulationImportValidateMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ValidateEcoModulationImportValidateMutationResponse,
    ResponseErrorConfig<Error>,
    ValidateEcoModulationImportValidateMutationRequest
  >({
    method: "POST",
    url: `/v1/eco-modulations/validate-import`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function validateEcoModulationImportValidateMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<ValidateEcoModulationImportValidateMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = validateEcoModulationImportValidateMutationKey()
  return mutationOptions<
    ResponseConfig<ValidateEcoModulationImportValidateMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateEcoModulationImportValidateMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return validateEcoModulationImport(data, config)
    },
  })
}

/**
 * @description Validates CSV content, matches products, and caches pending upserts when there are no errors.
 * @summary Validate eco-modulation import CSV (Step 1)
 * {@link /v1/eco-modulations/validate-import}
 */
export function useValidateEcoModulationImport<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ValidateEcoModulationImportValidateMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: ValidateEcoModulationImportValidateMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<ValidateEcoModulationImportValidateMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ??
    validateEcoModulationImportValidateMutationKey()

  const baseOptions = validateEcoModulationImportValidateMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ValidateEcoModulationImportValidateMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateEcoModulationImportValidateMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ValidateEcoModulationImportValidateMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateEcoModulationImportValidateMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ValidateEcoModulationImportValidateMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateEcoModulationImportValidateMutationRequest },
    TContext
  >
}
